<ng-container *ngIf="load">
    <app-company-checker></app-company-checker>
    <router-outlet></router-outlet>
    <app-version-checker #vercheck></app-version-checker>
</ng-container>

<ng-container *ngIf="!load">
    <div id="loader"><img src="assets/img/loader-preview.svg" alt="loading"></div>
</ng-container>